module.exports = __webpack_public_path__ + "img/icon-double-arrow.ee777e47.svg";